import request from '@/utils/request'

export function pageAnnouncement (query) {
  return request({
    url: '/diandian/announcement/page',
    method: 'get',
    params: query
  })
}

export function listAnnouncement (query) {
  return request({
    url: '/diandian/announcement/list',
    method: 'get',
    params: query
  })
}

export function getAnnouncement (data) {
  return request({
    url: '/diandian/announcement/detail',
    method: 'get',
    params: data
  })
}

export function addAnnouncement (data) {
  return request({
    url: '/diandian/announcement/add',
    method: 'post',
    data: data
  })
}

export function updateAnnouncement (data) {
  return request({
    url: '/diandian/announcement/edit',
    method: 'post',
    data: data
  })
}

export function delAnnouncement (data) {
  return request({
    url: '/diandian/announcement/delete',
    method: 'post',
    data: data
  })
}

export function markReadAnnouncement (data) {
  return request({
    url: '/diandian/announcement/mark-read',
    method: 'post',
    data: data
  })
}

export function markAllReadAnnouncement () {
  return request({
    url: '/diandian/announcement/mark-all-read',
    method: 'post'
  })
}
